import React from 'react'
import axios from 'axios'
import { apiURL } from 'src/consumer/services'

export async function addSubscriber(email, subsName, department, designation, packages, country) {
  const token = localStorage.getItem('token')
  const countryCode = localStorage.getItem('countryCode')
  const languageCode = sessionStorage.getItem('languageCode')
  const body = {
    businessMember: {
      name: subsName,
      email: email,
      packageId: packages,
    },
    userProfileResponse: {
      designation: designation,
      department: department,
      officeLocation: country,
    },
  }
  try {
    const res = await axios.post(
      `${apiURL}/api/secure/bc/subscribers/save?languageCode=${languageCode}&countryCode=${countryCode}`,
      body,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    )
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}
